import React, { useState, useEffect } from "react";
import { Row, Col, Radio, Button, Typography, message, Input } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import loader from "../../assets/loader.gif";
import success from "../../assets/successTick.gif";
import reject from "../../assets/reject.svg";
import bgImg from "../../assets/bg_img.jpg";
import upi from "../../assets/upi.svg";
import gpay from "../../assets/gpay.svg";
import phonePay from "../../assets/phonePay.svg";
import paytm from "../../assets/paytm.svg";
import cred from "../../assets/cred.svg";
import styles from "./payment.module.css";
import { useAllProduct } from "../../components/api-context/commonApiContext";
import { useNavigate } from "react-router-dom";
import Config from "../../config/Config";
import arrowleft from "../../assets/back-arrow.svg";

const { Title, Text } = Typography;

const Payment = () => {
  const { merchantInfo, intentLink, setMoneyLoadStatus } = useAllProduct();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedApp, setSelectedApp] = useState("");
  const [paymentProgress, setPaymentProgress] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [moneyLoadingFailed, setMoneyLoadingFailed] = useState(false);
  const navigate = useNavigate();

  const totalAmount = merchantInfo.amount;

  const upiApps = intentLink
    ? [
        {
          id: "gpay",
          label: "Google Pay",
          icon: gpay,
          offer: "0.5% Fee",
          intent: `intent://${
            intentLink.split("upi://")[1]
          }#Intent;scheme=upi;package=com.google.android.apps.nbu.paisa.user;end`,
        },
        {
          id: "phonepe",
          label: "PhonePe",
          icon: phonePay,
          offer: "1% Fee",
          intent: `intent://${
            intentLink.split("upi://")[1]
          }#Intent;scheme=upi;package=com.phonepe.app;end`,
        },
        {
          id: "paytm",
          label: "Paytm",
          icon: paytm,
          offer: "0.75% Fee",
          intent: `intent://${
            intentLink.split("upi://")[1]
          }#Intent;scheme=upi;package=net.one97.paytm;end`,
        },
        {
          id: "cred",
          label: "Cred",
          icon: cred,
          offer: "2% Fee",
          intent: `intent://${
            intentLink.split("upi://")[1]
          }#Intent;scheme=upi;package=com.dreamplug.androidapp;end`,
        },
        {
          id: "generic",
          label: "Pay using your UPI app",
          icon: upi,
          intent: intentLink,
        },
      ]
    : [];

  // useEffect(() => {
  //   if (!merchantInfo?.payment_id || !paymentProgress) return;
  //   setIsLoading(true);

  //   let intervalId;
  //   let poll = 0;

  //   const pollStatus = async () => {
  //     try {
  //       const res = await fetch(`${Config.node_api_endpoint}/get-user-status`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-API-Key": process.env.REACT_APP_API_KEY,
  //         },
  //         body: JSON.stringify({ payment_id: merchantInfo.payment_id }),
  //       });

  //       const result = await res.json();
  //       if (!result.success) return;

  //       const status =
  //         typeof result.data.status === "string"
  //           ? result.data.status
  //           : result?.data?.status?.status;

  //       console.log("Status:", status);

  //       if (status === "completed") {
  //         setPaymentSuccess(true);
  //         setIsLoading(false);
  //         clearInterval(intervalId);
  //       }

  //       if (status === "failed") {
  //         setIsLoading(false);
  //         clearInterval(intervalId);
  //         message.error("Payment failed, try again.");
  //         navigate("/cart");
  //       }

  //       if (++poll > 40) {
  //         clearInterval(intervalId);
  //         message.warning("Timeout! Try again.");
  //         navigate("/cart");
  //       }
  //     } catch {
  //       setIsLoading(false);
  //       clearInterval(intervalId);
  //     }
  //   };

  //   intervalId = setInterval(pollStatus, 2000);

  //   return () => clearInterval(intervalId);
  // }, [paymentProgress]);

  useEffect(() => {
    const paymentId = merchantInfo?.payment_id;
    if (!paymentId) return;

    const checkStatus = async () => {
      try {
        setIsLoading(true);

        const res = await fetch(`${Config.node_api_endpoint}/get-user-status`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": process.env.REACT_APP_API_KEY,
          },
          body: JSON.stringify({ payment_id: paymentId }),
        });

        const result = await res.json();
        if (!result.success) {
          setIsLoading(false);
          message.error("Unable to fetch payment status. Please try again.");
          return;
        }

        const status =
          typeof result.data?.status === "string"
            ? result.data.status
            : result?.data?.status?.status;

        console.log("Status:", status);

        if (status === "completed") {
          setPaymentSuccess(true);
        } else if (status === "failed") {
          setMoneyLoadingFailed(true);
          message.error("Payment failed. Try again.");
          navigate("/cart");
        } else {
          message.info("Payment is still processing. Please wait.");
        }
      } catch (error) {
        message.error("Network error. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };

    checkStatus();
  }, [merchantInfo?.payment_id, paymentProgress, navigate]);

  const handlePayment = () => {
    if (!selectedApp) {
      message.error("Select a UPI App");
      return;
    }
    setPaymentProgress(true);
    setIsLoading(true);
    setMoneyLoadStatus("pending");

    const app = upiApps.find((a) => a.id === selectedApp);
    if (app) window.location.href = app.intent;
  };

  if (isLoading && !paymentSuccess) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={loader} width="120" alt="loading" />
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        minHeight: "100vh",
        padding: "50px 16px",
        color: "#fff",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 20,
          height: 40,
        }}
      >
        <img
          src={arrowleft}
          style={{ cursor: "pointer" }}
          alt="Back"
          onClick={() => navigate("/cart")}
        />

        <Title
          level={4}
          style={{
            color: "#333333",
            margin: 0,
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            // width: "100%",
            textAlign: "center",
          }}
        >
          Payment
        </Title>
      </div>
      <Text style={{ color: "#fff", fontWeight: 700, fontSize: "18px" }}>
        <span style={{ color: "#333333" }}>Welcome to </span>{" "}
        <span style={{ color: "#2348AB" }}>Khazana Card</span>
      </Text>

      {moneyLoadingFailed ? (
        <div style={{ textAlign: "center", marginTop: 60 }}>
          <img src={reject} width="180" alt="failed" />
          <Text
            style={{
              display: "block",
              marginTop: 15,
              color: "#000",
              fontWeight: "600",
              fontSize: 18,
            }}
          >
            Money loading failed.
          </Text>
          <Button
            className="w-100"
            type="primary"
            size="large"
            onClick={() => navigate("/cart")}
            style={{
              marginTop: 24,

              background: "#2348AB",
              borderRadius: 10,
            }}
          >
            Retry
          </Button>
        </div>
      ) : paymentSuccess ? (
        <div style={{ textAlign: "center", marginTop: 60 }}>
          <img src={success} width="180" alt="success" />
          <Text
            style={{
              display: "block",
              marginTop: 15,
              color: "#000",
              fontSize: 18,
              fontWeight: "600",
            }}
          >
            Money successfully loaded.
          </Text>
          <Button
            className="w-100"
            type="primary"
            size="large"
            onClick={() => navigate("/cart")}
            style={{ marginTop: 24, background: "#2348AB", borderRadius: 10 }}
          >
            Go Back to Redeem
          </Button>
        </div>
      ) : (
        <>
          <Title level={4} style={{ marginTop: 20, color: "#000" }}>
            Payment
          </Title>
          <Title style={{ marginTop: 10, color: "#9E9EA0", fontSize: "13px" }}>
            Select your preferred <span style={{ color: "#000" }}>UPI</span> app
            to complete the transaction.
          </Title>
          <div style={{ marginTop: 24 }}>
            <Radio.Group
              value={selectedApp}
              onChange={(e) => setSelectedApp(e.target.value)}
              style={{ width: "100%" }}
            >
              {upiApps.map((app) => (
                <div
                  key={app.id}
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: 10,
                    padding: 12,
                    marginBottom: 12,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {" "}
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 10 }}
                  >
                    {" "}
                    <img src={app.icon} alt={app.label} width={30} />{" "}
                    <div>
                      {" "}
                      <Text style={{ fontWeight: 500, display: "block" }}>
                        {" "}
                        {app.label}{" "}
                      </Text>{" "}
                      <Text
                        style={{
                          color: "#A9ADB5",
                          fontSize: 12,
                          display: "block",
                        }}
                      >
                        {" "}
                        {app.offer} {/* (₹{getOfferAmount(app.offer)}) */}{" "}
                      </Text>{" "}
                    </div>{" "}
                  </div>{" "}
                  <Radio value={app.id} />{" "}
                </div>
              ))}
            </Radio.Group>
          </div>
          {/*  Commented out UPI ID Input */}
          <Title level={4} style={{ marginTop: 20, color: "#000" }}>
            Pay via UPI ID
          </Title>
          <Title
            style={{
              marginTop: 10,
              marginBottom: 10,
              color: "#9E9EA0",
              fontSize: "13px",
            }}
          >
            Enter your preferred
            <span style={{ color: "#000" }}> UPI ID </span>to complete the
            transaction.{" "}
          </Title>
          <Text style={{ color: "#333333", fontSize: 14, fontWeight: 600 }}>
            Enter UPI ID
          </Text>

          <Input className="p-2 mt-2" placeholder="Enter UPI ID" />

          <Button
            type="primary"
            block
            disabled={!selectedApp}
            style={{ marginTop: 28, background: "#2348AB", borderRadius: 10 }}
            onClick={handlePayment}
            size="large"
          >
            Pay ₹{totalAmount}
          </Button>
        </>
      )}
    </div>
  );
};

export default Payment;
